// extracted by mini-css-extract-plugin
export var vid = "style-module--vid--31d7c";
export var vidWrap = "style-module--vidWrap--6395c";